import React, {FC, PropsWithChildren} from 'react';

import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {ChromelessButton} from '../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../libs/shared/ui/src/styles/mixins';
import {styled} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface BannerActionProps {
  onClick: Handler;
  className?: string;
  isDisabled?: boolean;
  interactionId?: string;
}

/*
 * Style.
 */

export const StyledActionButton = styled(ChromelessButton)<BannerActionProps>`
  cursor: pointer;
  position: relative;
  grid-area: action;

  padding: 0 8px;
  border-radius: 13px;

  color: ${(p) => p.theme.bannerText};
  font-size: ${fontSizes.tiny};
  font-weight: ${fontWeights.bold};
  line-height: 26px;
  text-transform: uppercase;

  ${ellipsis()};

  &:hover {
    background-color: ${(p) => p.theme.bannerActionHover};
  }
`;

/*
 * Component.
 */

export const BannerAction: FC<PropsWithChildren<BannerActionProps>> = (props) => (
  <StyledActionButton
    onClick={props.onClick}
    className={props.className}
    isDisabled={props.isDisabled}
    interactionId={props.interactionId}
  >
    {props.children}
  </StyledActionButton>
);
